<template>
    <div class="text-center">
        <pulse-loader :loading="loading"></pulse-loader>

        <div v-if="!loading">
            <h2>Seleziona il marchio</h2>
            <div class="row justify-content-center">
                <div
                    class="col-md-4 col-xs-12 mb-4"
                    v-for="brand in brands"
                    v-bind:key="brand.id"
                    v-if="brand.image"
                >
                    <div class="brand card-hover">
                        <router-link
                            :to="{ name: 'brand', params: { id: brand.id } }"
                        >
                            <div class="brand-image p-4">
                                <img
                                    :src="brand.image.medium"
                                    :alt="brand.name"
                                    class="img-fluid"
                                />
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../sass/common/mixins";
.brand {
    a {
        display: block;
        cursor: pointer;
    }
    &:hover {
        opacity: 0.8;
    }

    .brand-image {
        height: 180px;

        img {
            @include center();
        }
    }
}
</style>

<script>
import BrandMixin from "../mixins/Brand";
export default {
    mixins: [BrandMixin],
    mounted() {
        this.getBrands().then((response) => {
            this.brands = response.data.data;
            if (this.brands.length === 1) {
                this.$router.push({
                    name: "brand",
                    params: { id: this.brands[0].id },
                });
            } else {
                this.loading = false;
            }
        });
    },
    data: function () {
        return {
            brands: null,
            loading: true,
        };
    },
};
</script>
